// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1_wLU","checkboxCol":"Table_checkboxCol__1RvQN","emailCol":"Table_emailCol__3jTf8","actionCol":"Table_actionCol__1Rb-N"};